import {
  Bar,
  BarChart as RechartsBarChart,
  ResponsiveContainer,
  Tooltip,
  TooltipProps,
  XAxis,
  YAxis,
} from 'recharts';

interface BarChartProps {
  data: Record<string, number | string>[];
  index: string;
  categories: string[];
  colors?: string[];
  valueFormatter?: (value: number) => string;
}

const formatValue = (value: number | string) => {
  if (typeof value === 'number') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(value);
  }
  return value;
};

const CustomTooltip = ({ active, payload, label }: TooltipProps<number | string, string>) => {
  if (!active || !payload?.length) return null;

  return (
    <div className="rounded-sm bg-white py-1 px-4 shadow-sm border border-gray-100">
      <div className="text-sm font-medium text-gray-900">{label}</div>
      <div className="text-sm font-semibold text-[#0ea5e9]">
        {payload[0].value !== undefined ? formatValue(payload[0].value) : ''}
      </div>
    </div>
  );
};

export function BarChart({
  data,
  index,
  categories,
  colors = ['#0ea5e9'],
  valueFormatter = (value: number) => `${value}`,
}: BarChartProps) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <RechartsBarChart data={data}>
        <XAxis dataKey={index} stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
        <YAxis
          stroke="#888888"
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={valueFormatter}
        />
        <Tooltip wrapperStyle={{ outline: 'none' }} content={<CustomTooltip />} />
        {categories.map((category, i) => (
          <Bar
            key={category}
            dataKey={category}
            fill={colors[i % colors.length]}
            radius={[2, 2, 0, 0]}
          />
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
}
